import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_ZqA4y0025e6j: {
	id: 'prd_ZqA4y2DEV20025e6j'
	ident: 'prd_ZqA4y0025e6j'
	sku: 'simple_premium_12w_24_99_12w_99_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_Z3Uis2DEV2iEmNjJx'
			amount: 99.99
			amount_usd: 24.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 24.99
			discount: 75
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_mcEuN2DEV2K4ogpYS'
			amount: 99.99
			amount_usd: 99.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_ZqA4y0025e6j, SubscriptionProduct>
const prd_ZqA4y0025e6j = { ident: 'prd_ZqA4y0025e6j' } as typeof _prd_ZqA4y0025e6j

export default prd_ZqA4y0025e6j
